module.exports = __webpack_public_path__ + "static/1928-c0b0ed93b2378c66ee223fb5db767b09.png";